module.exports = __webpack_public_path__ + "assets/img/baz1.05fdade1.png";